import { FORTA_ERROR } from '../../../../utils/colors';

import type { CSSProperties } from 'react';
import type { ResolveFormDateFieldPickerStyleParams } from './types';

export function resolveFormDateFieldPickerStyle({
  pickerStyle,
  hasError,
  disabled,
}: ResolveFormDateFieldPickerStyleParams): CSSProperties | undefined {
  if (pickerStyle == null) {
    return undefined;
  }

  return {
    ...pickerStyle,
    borderBottom: hasError
      ? `1px solid ${FORTA_ERROR}`
      : pickerStyle.borderBottom,
    cursor: disabled ? 'not-allowed' : pickerStyle.cursor,
    opacity: disabled ? 0.38 : pickerStyle.opacity,
    boxShadow: disabled ? pickerStyle.boxShadow : 'none',
  };
}
